import React from 'react';

import classNames from 'classnames';

import { Chip } from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import {
    ChevronUp,
    ChevronDown,
} from 'wanderu-icons';

import styles from './DropdownPill.scss';

import type { TFunction } from 'i18next';

interface DropdownIconProps {
    isOpen?: boolean;
    t: TFunction;
}

const DropdownIcon = (props: DropdownIconProps) => {
    const { isOpen, t } = props;
    const Icon = isOpen
        ? ChevronUp
        : ChevronDown;
    const title = isOpen
        ? t('hide-details_tripDetails')
        : t('show-details_tripDetails');

    return (
        <Icon
            className={styles.chevron}
            title={title}
        />
    );
};

const DropdownIconLocalized = localize(DropdownIcon, ['t'], 'baseApp');

interface DropdownPillProps {
    className?: string;
    isOpen?: boolean;
    onToggle?: (e: React.MouseEvent) => void;
    text: string;
}

export default function DropdownPill(props: DropdownPillProps) {
    const {
        className = '',
        isOpen = false,
        onToggle = () => undefined,
        text,
    } = props;

    return (
        <Chip
            Component="button"
            aria-expanded={isOpen}
            className={classNames(styles.chip, className)}
            onClick={onToggle}
            rightIcon={<DropdownIconLocalized isOpen={isOpen} />}
            text={text}
        />
    );
}
